import type { ReceiptMachineInput, ValidOrder } from '../receipt.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const getInitialInput: ReceiptMachineInput<{ receiptId: string }> = (args) => {
  return { receiptId: args.context.receiptId };
};

export const getClaimReceiptInput: ReceiptMachineInput<{ order: ValidOrder }> = (args) => {
  const { order } = args.context;

  if (!order) {
    throw new Error('Missing receipt data for claim');
  }

  return { order };
};
